import { render } from "./PageWrapper.vue?vue&type=template&id=99030590&scoped=true"
import script from "./PageWrapper.vue?vue&type=script&lang=js"
export * from "./PageWrapper.vue?vue&type=script&lang=js"

import "./PageWrapper.vue?vue&type=style&index=0&id=99030590&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99030590"]])

export default __exports__